export var AudioFileContainerDirection;

(function (AudioFileContainerDirection) {
  AudioFileContainerDirection["VERTICAL"] = "vertical";
  AudioFileContainerDirection["HORIZONTAL"] = "horizontal";
})(AudioFileContainerDirection || (AudioFileContainerDirection = {}));